import { useState, type FC, type ReactNode } from "react"

import styles from "./SouhlAdminLayout.module.scss"

import SouhlAdminSidebar from "@/souhl_admin/components/features/sidebar/SouhlAdminSidebar"

type SouhlAdminLayoutProps = {
	children: ReactNode
}

const SouhlAdminLayout: FC<SouhlAdminLayoutProps> = ({ children }) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(
		() => typeof window !== "undefined" && window.innerWidth >= 768
	)

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen)
	}

	return (
		<div className={styles.layout}>
			<SouhlAdminSidebar isOpen={isSidebarOpen} />
			<div className={styles.contentWrapper}>
				<header className={styles.header}>
					<button
						className={styles.toggleButton}
						onClick={toggleSidebar}
						aria-label={
							isSidebarOpen ? "サイドバーを閉じる" : "サイドバーを開く"
						}
					>
						{isSidebarOpen ? "◀" : "▶"}
					</button>
					<span className={styles.headerTitle}>SOUHL Admin</span>
				</header>
				<div className={styles.mainContent}>{children}</div>
			</div>
		</div>
	)
}

export default SouhlAdminLayout
